import { render, staticRenderFns } from "./FormProcessor.vue?vue&type=template&id=4f960759&scoped=true"
import script from "./FormProcessor.vue?vue&type=script&lang=ts"
export * from "./FormProcessor.vue?vue&type=script&lang=ts"
import style0 from "./FormProcessor.vue?vue&type=style&index=0&id=4f960759&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f960759",
  null
  
)

export default component.exports